import { configureStore } from '@reduxjs/toolkit'
import AppApi from './network/API'
import ActivePageReducer from './ActivePageSlice'
import MapDataSlice from './MapDataSlice'

const isDevelopment = process.env.REACT_APP_SERVER === 'DEV'

export const store = configureStore({
  reducer: {
    ActivePage: ActivePageReducer,
    MapData: MapDataSlice,
    [AppApi.reducerPath]: AppApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(AppApi.middleware),
  devTools: isDevelopment,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
